import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { UsersWalletAddressResponse } from "../models/response/userWalletAddressResponse";
import { 
  UserPendingWithdrawalResponse, 
  WithdrawVerificationStatusResponse, 
  WithdrawalRevertRequest, 
  WithdrawFlowResponse,
  UserWithdrawalSummaryResponse,
  WithdrawTypeListResponse,
  UserBankDetailsListResponse,
  WithdrawFeesTypeListResponse,
  UserActiveBonusResponse,
  UserActiveFreeSpinBonusResponse,
  FreeSpinBonusHistoryFromProviderResponse,
  FreeSpinBonusHistoryFromProviderRequest,
  AbcPaymentInitiateWithdrawReuest,
  AbcPaymentInitiateWithdrawResponse,
  DragonWithdrawCreateRequest,
  cryptoCurrencyListResponse,
  ExchangeRatesResponse,
  AbcPaymentInitiateCryptoResponse
} from "../models";
import { DragonWithdrawCreateResponse } from "../models/response/dragonWithdrawCreateResponse";
import { WithdrawCreateRequest } from "../models/request/withdrawCreateRequest";

export const withdrawApi = {
  getWithdrawVerificationStatus: async (): Promise<UnifiedResponse<WithdrawVerificationStatusResponse>
  > => {
    const response = await apiClient.get<
      UnifiedResponse<WithdrawVerificationStatusResponse>
    >("/account/select_withdraw");
    return response.data;
  },

  getUserPendingWithdrawals: async (): Promise<
    UnifiedResponse<UserPendingWithdrawalResponse>
  > => {
    const response = await apiClient.post<
      UnifiedResponse<UserPendingWithdrawalResponse>
    >(
      `/payment/withdraw/retrieve_last_request`
    );
    return response.data;
  },

  revertUserWithdrawal: async (
    request: WithdrawalRevertRequest
    ): Promise<UnifiedResponse<any>> => {
      const response = await apiClient.post<UnifiedResponse<any>>(
        `/payment/withdraw/cancel`,
        request,
      );
      return response.data;
  },

  getWithdrawFlowDetails: async (): Promise<UnifiedResponse<WithdrawFlowResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<WithdrawFlowResponse>
    >("/select/withdraw/flow", {});
    return response.data;
  },

  getUserWithdrawSummary: async (): Promise<
    UnifiedResponse<UserWithdrawalSummaryResponse>
  > => {
    const response = await apiClient.get<
      UnifiedResponse<UserWithdrawalSummaryResponse>
    >(`/payment/user_deposit_withdraw/select`, {});
    return response.data;
  },

  getWithdrawTypes: async (
    withdrawFlow: string
  ): Promise<UnifiedResponse<WithdrawTypeListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<WithdrawTypeListResponse>
    >(
      "/payment/withdraw_type/select",
      withdrawFlow,      
    );
    return response.data;
  },

  getUserBankDetailsList: async (
  ): Promise<UnifiedResponse<UserBankDetailsListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<UserBankDetailsListResponse>
    >(
      "/user_bank/retrieve/dropdown",
      { id: null },
    );
    return response.data;
  },

  getWithdrawFeesTypesList: async (
  ): Promise<UnifiedResponse<WithdrawFeesTypeListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<WithdrawFeesTypeListResponse>
    >(
      "/payment/withdraw_fees/retrieve",
      { id: null },
    );
    return response.data;
  },

  getUserActiveBonusCount: async (): Promise<UnifiedResponse<UserActiveBonusResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<UserActiveBonusResponse>
    >("/bonus/count/retrieve_by_userid", { id: null });
    return response.data;
  },

  getUserActiveFreeSpinBonusDetails: async (): Promise<UnifiedResponse<UserActiveFreeSpinBonusResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<UserActiveFreeSpinBonusResponse>
    >("/bonus/qtech/get_active_freespin_details", { id: null });
    return response.data;
  },

  getFreeSpinBonusHistoryFromProvider: async (request: FreeSpinBonusHistoryFromProviderRequest): Promise<UnifiedResponse<FreeSpinBonusHistoryFromProviderResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<FreeSpinBonusHistoryFromProviderResponse>
    >("/bonus/qtech/get_free_spin_bonus_history_from_provider", request);
    return response.data;
  },

  abcWithdrawInitiate: async (request: AbcPaymentInitiateWithdrawReuest): Promise<UnifiedResponse<AbcPaymentInitiateWithdrawResponse>> => {
    const response = await apiClient.post<UnifiedResponse<AbcPaymentInitiateWithdrawResponse>>(
      "/abc_payment/withdraws/initiate",
      request
    );
    return response.data;
  },

  withdrawInsert: async (request: WithdrawCreateRequest): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/payment/withdraw/insert",
      request
    );
    return response.data;
  },

  dragonWithdrawCreate: async (request: DragonWithdrawCreateRequest): Promise<UnifiedResponse<DragonWithdrawCreateResponse>> => {
    const response = await apiClient.post<UnifiedResponse<DragonWithdrawCreateResponse>>(
      "/dragon/payment/create/withdraw",
      request
    );
    return response.data;
  },

  getCryptoCurrenciesList: async (): Promise<
    UnifiedResponse<cryptoCurrencyListResponse>
  > => {
    const response = await apiClient.get<
      UnifiedResponse<cryptoCurrencyListResponse>
    >("/abc_crypto_payment/crypto/currencies/list");
    return response.data;
  },

  getUserWalletAddress: async (): Promise<
    UnifiedResponse<UsersWalletAddressResponse>
  > => {
    const response = await apiClient.get<
      UnifiedResponse<UsersWalletAddressResponse>
    >("/payment/users_wallet_address/select");
    return response.data;
  },

  insertWalletAddress: async (
    walletAddress: string
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/payment/abc_payment/users_wallet_address/insert",
      { walletAddress },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },

  getExchangeRates: async (
    amount: number
  ): Promise<UnifiedResponse<ExchangeRatesResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<ExchangeRatesResponse>
    >(
      "/abc_crypto_payment/ExchangeRates",
      amount,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },

  sendMobileVerificationCodeForWalletAddress: async(): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.get<UnifiedResponse<any>>("/users/send_mobile_otp/wallet_address");
    return response.data;
  },

  verifyMobileVerificationCodeForWalletAddress: async(code: string): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>("users/wallet_address/verify_mobile_otp", { otp: code });
    return response.data;
  },

  walletAddressSubmit: async (walletaddress: string): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>
      ("/payment/users_wallet_address/insert", 
        walletaddress,
    )
    return response.data;
  },

  cryptoWithdrawInitiate: async (amount: number): Promise<UnifiedResponse<AbcPaymentInitiateCryptoResponse>> => {
    const response = await apiClient.post<UnifiedResponse<AbcPaymentInitiateCryptoResponse>>("/abc_crypto_payment/crypto/withdraw/initiate", {amount});
    return response.data;
  },
};

export default withdrawApi;
